/**
 * Horizontal tab strip (CZNA-360 — variant C redesign of TASK-181 WP-B CP-1).
 *
 * Renders the flat, chip-style tab row: text + bottom-border underline on
 * the active tab, no card border/background, no inline rename/delete/grip
 * icons. Clicking a tab is still a single click that switches the active
 * tab — no regression versus the previous behaviour.
 *
 * Administration (rename / delete / reorder / add) has moved out of this
 * row into `TabManagementModal`, opened via the "⋯" overflow button at the
 * end of the strip (`margin-left: auto`). This component owns only the
 * `open`/`onClose` wiring for that modal; all mutation logic lives in the
 * modal component.
 */
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { IconButton } from '@folio/stripes/components';
import { readCsLabel } from './labelUtils';
import TabManagementModal from './TabManagementModal';
var TabListEditor = function (_a) {
    var tabs = _a.tabs, activeTabIdx = _a.activeTabIdx, onSelectTab = _a.onSelectTab, dispatch = _a.dispatch, recordTypeLabel = _a.recordTypeLabel;
    var intl = useIntl();
    var _b = useState(false), modalOpen = _b[0], setModalOpen = _b[1];
    return (React.createElement("div", { "data-testid": "tab-list-editor" },
        React.createElement("div", { "data-testid": "tab-list-container", style: {
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'flex-end',
                borderBottom: '1px solid #ccc',
                marginBottom: '0.75rem',
            } },
            tabs.map(function (tab, idx) {
                var isActive = idx === activeTabIdx;
                return (React.createElement("div", { key: tab.id, "data-testid": "tab-row-".concat(idx), role: "button", tabIndex: 0, "aria-current": isActive ? 'true' : undefined, style: {
                        display: 'inline-flex',
                        alignItems: 'center',
                        padding: '9px 4px',
                        marginRight: '1rem',
                        marginBottom: '-1px', // overlap container's bottom border by 1px so the active underline aligns with it
                        borderBottom: isActive ? '2px solid #0070c0' : '2px solid transparent',
                        cursor: 'pointer',
                        whiteSpace: 'nowrap',
                        maxWidth: '240px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        color: isActive ? '#0070c0' : '#444',
                        fontWeight: 600,
                    }, onClick: function () { return onSelectTab(idx); }, onKeyDown: function (e) {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            onSelectTab(idx);
                        }
                    }, title: readCsLabel(tab.label) || tab.id }, readCsLabel(tab.label) || tab.id));
            }),
            React.createElement(IconButton, { icon: "ellipsis", onClick: function () { return setModalOpen(true); }, ariaLabel: intl.formatMessage({ id: 'ui-czna-authorities.settings.forms.visual.tabs.manageBtn.aria' }), "data-testid": "tab-list-manage-btn", style: { marginLeft: 'auto', marginBottom: '0.25rem' } })),
        React.createElement(TabManagementModal, { open: modalOpen, tabs: tabs, activeTabIdx: activeTabIdx, onSelectTab: onSelectTab, dispatch: dispatch, onClose: function () { return setModalOpen(false); }, recordTypeLabel: recordTypeLabel })));
};
export default TabListEditor;
